import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import { useTourPageContext } from "../../_client/context";
import style from "./TourHeroSummaryInfo.module.scss";

export const TourHeroGroupSize: React.FC = () => {
    const { tourContent } = useTourPageContext();
    const { productPage } = useI18n("productPage");

    if (!tourContent.minimumGroupSize || !tourContent.maximumGroupSize) {
        return null;
    }

    return (
        <Text tag="dl" className={style["summary-info-detail-wrapper"]}>
            <Text tag="dt">
                {productPage.tourHero.heroSummary.groupSize.l()}
            </Text>
            <Text
                tag="dd"
                emphasis="1"
                className={style["summary-info-detail"]}
            >
                {productPage.tourHero.heroSummary.groupSizeDetail.l({
                    minimum: `${tourContent.minimumGroupSize}`,
                    maximum: `${tourContent.maximumGroupSize}`,
                })}
            </Text>
        </Text>
    );
};
